(function () {
  var bar = document.querySelector("[data-bottom-bar]");
  if (!bar) return;

  function normalizeSvgColors(svg) {
    svg.querySelectorAll("[fill]").forEach(function (el) {
      var fill = el.getAttribute("fill");
      if (!fill || fill === "none" || fill === "currentColor") return;
      el.setAttribute("fill", "currentColor");
    });

    svg.querySelectorAll("[stroke]").forEach(function (el) {
      var stroke = el.getAttribute("stroke");
      if (!stroke || stroke === "none" || stroke === "currentColor") return;
      // Keep light decorative strokes (e.g. home door line)
      if (stroke.toUpperCase() === "#DAEAEF") return;
      el.setAttribute("stroke", "currentColor");
    });
  }

  function inlineSvg(img) {
    var src = img.getAttribute("src");
    if (!src) return;

    fetch(src)
      .then(function (res) {
        if (!res.ok) throw new Error("SVG fetch failed");
        return res.text();
      })
      .then(function (text) {
        if (text.indexOf("<svg") === -1) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(text, "image/svg+xml");
        var svg = doc.querySelector("svg");
        if (!svg || doc.querySelector("parsererror")) return;

        svg.classList.add("bottom-bar__icon");
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("width", "18");
        svg.setAttribute("height", "18");

        normalizeSvgColors(svg);
        img.replaceWith(svg);
      })
      .catch(function () {});
  }

  bar.querySelectorAll("img.bottom-bar__icon[data-bottom-bar-svg]").forEach(inlineSvg);
})();
